import { TextField } from "@mui/material";

export const MFAComponent: React.FC<{
  mfa: string;
  setMfa: (mfa: string) => void;
}> = ({ mfa, setMfa }) => (
  <TextField
    label="MFA Code"
    value={mfa}
    fullWidth
    onChange={(e) => setMfa(e.target.value)}
  />
);